import CompLayout from "@/pcomponents/comp/layout/layout";
import PlanMakeTodoArea from "@/pages/comp/plan/todo/common/make_todo";

function PlanMakeTodo() {
  return (
    <CompLayout>
      <PlanMakeTodoArea></PlanMakeTodoArea>
    </CompLayout>
  );
}

export default PlanMakeTodo;